import {BrowserApp, Device, MobileApp, OS} from '@web/core/constants'

import {browserUserAgent as userAgent} from './browser'

import type {BrowserAppType, DeviceType, MobileAppType} from '@web/core/constants'

export const isPC = userAgent.isPC

/**
 * iOS safari > 데스크탑 웹 사이트 요청시 isMobile:true isDesktop: true (iOS)
 * iOS chrome > 데스크탑 사이트로 보기 isMobile:true isDesktop: true (iOS)
 * AOS chrome > 데스크탑 사이트로 보기 isMobile:false isDesktop: true (linux)
 */
export const isMobileDisplay = userAgent.isMobileDisplay

export const isLinux = userAgent.isLinux

/** UA 키워드 별 앱 타입 목록 */
const mobileApps: Record<string, MobileAppType> = {
    search: MobileApp.NAVER,
    pay: MobileApp.NAVER_PAY,
    cafe: MobileApp.NAVER_CAFE,
    navershopping: MobileApp.NAVER_SHOPPING,
    'shopping-sdk': MobileApp.NAVER_SHOPPING,
    map: MobileApp.NAVER_MAP,
}

/** 네이버앱 UA 구분 */
export const getMobileAppType = (ua: string): MobileAppType => {
    /**
     * @see https://developers.naver.com/docs/openmain/#5--[%EC%B0%B8%EA%B3%A0]-%EB%84%A4%EC%9D%B4%EB%B2%84%EC%95%B1-%EA%B5%AC%EB%B6%84-%EB%B0%A9%EB%B2%95
     * @description 네이버앱(search) / 페이앱(pay) UA 정규식, 네이버앱 UA 구분 방법은 위 링크를 참조하시면 됩니다.
     *              카페앱(cafe) https://wiki.navercorp.com/pages/viewpage.action?pageId=224341009
     *              네이버쇼핑앱(navershopping|navershoppingbrowser|shopping-sdk) https://wiki.navercorp.com/display/NEWSHOPNAPP/0.+UserAgent+Interface
     */
    const appUserAgentRegEx =
        /NAVER\([inapp|higgs]+;[^0-9]*(search|pay|cafe|navershopping|navershoppingbrowser|shopping-sdk|map);[^0-9]*(\d+);[^0-9]*(\d+.\d+.\d+).*\)/gim
    const appMatchingData = appUserAgentRegEx.exec(ua) ?? []
    const appName = appMatchingData?.[1]

    return (appName ? mobileApps[appName] : MobileApp.UNKNOWN) ?? MobileApp.UNKNOWN
}

export const mobileAppType = getMobileAppType(userAgent.userAgent)
export const isCafeApp = userAgent.isCafeApp
export const isNaverApp = userAgent.isNaverApp
// navershoppingbrowser 는 네이버 쇼핑 앱내의 외부 브라우저로, 네이버 쇼핑 앱의 대응을 처리하지 않음
export const isNaverShopping = mobileAppType === MobileApp.NAVER_SHOPPING // userAgent.isNaverShopping
export const isPayApp = userAgent.isPayApp
export const isNaverMapApp = userAgent.isNaverMapApp

/** 네이버 서비스용 앱 목록 */
export const isNaverServiceApp = userAgent.isNaverServiceApp

export const getDeviceType = (): DeviceType => (userAgent.isMobile ? Device.MOBILE : Device.PC)
export const deviceType = getDeviceType()
export const getOSType = () => {
    if (userAgent.isAndroid) {
        return OS.ANDROID
    } else if (userAgent.isIOS) {
        return OS.IOS
    } else if (userAgent.isWindows) {
        return OS.WINDOWS
    } else if (userAgent.isMacOs) {
        return OS.MAC_OS
    } else if (userAgent.isLinux) {
        return OS.LINUX
    } else {
        return OS.ETC
    }
}
export const osType = getOSType()

export const getBrowserType = (): BrowserAppType => {
    if (userAgent.isChrome) {
        return BrowserApp.CHROME
    } else if (userAgent.isFirefox) {
        return BrowserApp.FIREFOX
    } else if (userAgent.isSafari) {
        return BrowserApp.SAFARI
    } else if (userAgent.isOpera) {
        return BrowserApp.OPERA
    } else if (userAgent.isIE) {
        return BrowserApp.IE
    } else if (userAgent.isEdge) {
        return BrowserApp.EDGE
    }
    return BrowserApp.ETC
}
export const browserType = getBrowserType()

export const isMobile = userAgent.isMobile
export const isIE = userAgent.isIE
export const isFirefox = userAgent.isFirefox
export const isDesktop = userAgent.isDesktop
export const isAndroid = userAgent.isAndroid
export const isIOS = userAgent.isIOS
export const isMacOs = userAgent.isMacOs
export const isWindows = userAgent.isWindows
export const isSafari = userAgent.isSafari
export const isChrome = userAgent.isChrome
export const isOpera = userAgent.isOpera
export const isEdge = userAgent.isEdge
export const isMobileOnly = userAgent.isMobileOnly

export const osName = userAgent.osName
export const getUA = userAgent.userAgent
